// "Sort by" dropdown in the collection toolbar (Filters block → Drawer direction).
// Sorting is submitted through the drawer form's own sort select so active filters are kept.
(() => {
  const closeAll = (except) => {
    document.querySelectorAll('[data-toolbar-sort][open]').forEach((details) => {
      if (details !== except) details.removeAttribute('open');
    });
  };

  const syncSelected = (details) => {
    const select = document.getElementById('SortBy-mobile');
    if (!select) return;
    details.querySelectorAll('[data-sort-value]').forEach((option) => {
      option.classList.toggle('is-selected', option.dataset.sortValue === select.value);
    });
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-sort-value]');
    const details = event.target.closest('[data-toolbar-sort]');

    if (!option) {
      closeAll(details);
      // The summary click opens the dropdown right after this handler runs
      if (details && !details.open) syncSelected(details);
      return;
    }

    const select = document.getElementById('SortBy-mobile');
    if (!select) return;

    select.value = option.dataset.sortValue;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    syncSelected(details);
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  });

  document.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') closeAll();
  });
})();
